module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAABcUlEQVR4Xu3bSw7CMAyEYXMduA+H5D5wHpRFpQrxaOyxPRORVVdR/k+NKqXtyXTG2cxuZnY1swdq2SfURMnzbPEXM7sjERQA9vGbMwyBHeBdPBSBGeBbPAyBFeBIPASBEWAmPozABuCJDyEwAUTi3QgsAIj4gTD9eGQAaIsfYt0ArfHdAO3xnQAU8V0ANPEdAFTx1QB08ZUAlPFVALTxFQDU8dkA9PGZABLxWQAy8RkAUvFoALl4JIBkPApANh4BIB0fBZCPjwAsEe8FWCbeA7BU/B/AeSq81F3gPRZfBsELMLbPEggRgCUQogDyCAgAaQQUgCwCEkASAQ0gh5ABIIWQBSCDkAkggZANQI9QAUCNUAVAi1AJQIlQDUCH0AFAhdAFQIPQCUCB0A3QjsAA0IrAAoBCkPxafMRvI3LQOh3veTGyX2zWtQfBFc8KMLsd3PHMAEcRQvHsAL8QwvEKAJ8QIPEqAK8IsHglgD0C9Pf5J8xDvkGzoMMvAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/left.png
// module id = xDWF
// module chunks = 0